import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

interface ClientChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
}

const ClientChip = ({ label, selected, onToggle }: ClientChipProps) => {
  return (
    <Chip
      label={label}
      onClick={onToggle}
      onDelete={selected ? onToggle : undefined}
      deleteIcon={<CloseIcon fontSize="small" />}
      icon={selected ? <CheckIcon fontSize="small" /> : undefined}
      variant={selected ? "filled" : "outlined"}
      color={selected ? "primary" : "default"}
      size="small"
      sx={{
        height: 32,
        fontSize: "0.8125rem",
        borderRadius: 1.5,
      }}
    />
  );
};

export default ClientChip;
